import { render, staticRenderFns } from "./productstandard.vue?vue&type=template&id=8d8353ce&scoped=true&"
import script from "./productstandard.vue?vue&type=script&lang=js&"
export * from "./productstandard.vue?vue&type=script&lang=js&"
import style0 from "./productstandard.vue?vue&type=style&index=0&id=8d8353ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8353ce",
  null
  
)

export default component.exports